/**
 * Created by pajicv on 10/7/18.
 */
import React from 'react';
import { Typography, Button, withStyles } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Close';
import { MAIN_COLOR } from '../../firebase-config';

const styles = theme => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: MAIN_COLOR,
        padding: 5
    },
    text: {
        color: '#fff',
        fontSize: 22,
    }
});

class Task extends React.Component {
    render() {
        const { project, task, subTasks, taskId, classes, onCloseTask } = this.props;
        if(!project || !task || !subTasks) return null;
        return (
            <div className={classes.container}>
                <Typography variant="title" color="secondary" gutterBottom style={{fontSize: 28, color: '#fff'}}>{`Cycle ${task.cycle.index + 1} > Task ${task.name}`}</Typography>
                <Button color="secondary" onClick={onCloseTask}><DeleteIcon color="#fff" /></Button>
            </div>
        );
    }
}

export default withStyles(styles)(Task);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskCollapsed.js